<template>
    <div class="loading__card" v-if="isShow">
        <q-spinner size="7.66vmin" style="color: #18b73f; z-index: 9999;" />
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineEmits, watch } from 'vue';

const isShow = ref(true);

const props = defineProps({
    'isShow': {
        default: false
    }
});

onMounted(() => {
    isShow.value = props.isShow;
})

watch(() => props.isShow, (newValue) => {
    isShow.value = newValue
});

onUnmounted(() => {
    isShow.value = false;
})
</script>

<style scoped lang="scss">
.loading__card {
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    // z-index: 9999;
}
</style>
